<template>
  <VeeForm ref="form" as="div">
    <slot />
  </VeeForm>
</template>

<script lang="ts">
export default { name: 'OForm' }
</script>

<script setup lang="ts">
import { Form as VeeForm } from 'vee-validate'

const form = ref<InstanceType<typeof VeeForm>>()

async function validate() {
  if (!form.value) {
    return false
  }

  const result = await form.value.validate()
  return result.valid
}

function reset() {
  form.value?.resetForm()
}

function setErrors(errors: unknown) {
  if (!errors || Array.isArray(errors) || typeof errors !== 'object') {
    return
  }

  const normalized = Object.fromEntries(
    Object.entries(errors).flatMap(([field, messages]) => {
      const message = Array.isArray(messages) ? messages[0] : messages

      return typeof message === 'string' && message
        ? [[field, message]]
        : []
    }),
  )

  form.value?.setErrors(normalized)
}

defineExpose({ validate, reset, setErrors })
</script>
